var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(-399 -5292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M418.966,5296.6l1.56,1.56-6.844,6.844h-1.56v-1.56l6.844-6.844m0-1.939a.988.988,0,0,0-.7.3l-7.5,7.5a.908.908,0,0,0-.3.7v2.5a.945.945,0,0,0,1,1h2.5a.907.907,0,0,0,.7-.3l7.5-7.5a.967.967,0,0,0,0-1.4l-2.5-2.5a.986.986,0,0,0-.7-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M417.035,5315.334h-8.8a.838.838,0,1,1,0-1.676h8.8a1.257,1.257,0,1,0,0-2.513H404.468a2.933,2.933,0,1,1,0-5.865H407.4a.838.838,0,0,1,0,1.676h-2.932a1.257,1.257,0,1,0,0,2.513h12.567a2.932,2.932,0,1,1,0,5.865Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 26,
    height: 26,
    transform: "translate(399 5292)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDraw);
export default __webpack_public_path__ + "static/media/icon-draw.5ee4e5f64a706fd6789ff0603bad27c5.svg";
export { ForwardRef as ReactComponent };